import type { paths } from "@/api-schema";
import { Can } from "@/casl-provider";
import { useVehicleByUuidQuery } from "@/common/api/vehicle/use-vehicle-by-uuid.query";
import { UuidExistenceWrapper } from "@/components/uuid-existence-wrapper/uuid-existence-wrapper";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useSearch } from "wouter";
import { VehicleValuationCreateByUuidView } from "./vehicle-valuation-create-by-uuid.view";
import { VehicleValuationCreateByVinView } from "./vehicle-valuation-create-by-vin.view";

export function CreateView() {
  const { t } = useTranslation(["fab", "masterdata"]);
  const [_, setLocation] = useLocation();
  const search = useSearch();
  const searchParams = new URLSearchParams(search);
  const vehicleUuid = searchParams.get("vehicleUuid");
  const vin = searchParams.get("vin");
  const shouldRedirect = vin === null && vehicleUuid === null;

  useEffect(() => {
    if (!shouldRedirect) return;

    setLocation("~/fab/list/initialize/select-vehicle", { replace: true });
  }, [setLocation, shouldRedirect]);

  if (vin) {
    return (
      <Can I="create" a="VehicleValuation">
        <VehicleValuationCreateByVinView vin={vin} />
      </Can>
    );
  }

  if (vehicleUuid) {
    return (
      <Can I="create" a="VehicleValuation">
        <UuidExistenceWrapper<
          paths["/v1/vehicle/{uuid}"]["get"]["parameters"]["query"],
          paths["/v1/vehicle/{uuid}"]["get"]["responses"][200]["content"]["application/json"]
        >
          uuid={vehicleUuid}
          query={useVehicleByUuidQuery}
          notFoundProps={{
            title: t("masterdata:VehicleNotFound"),
            message: t("fab:RequestedVehicleDoesNotExist"),
            description: t("fab:PleaseCheckVehicleIdOrContactSupport"),
            backTo: "~/fab/list/initialize/select-vehicle",
            backToLabel: t("fab:BackToVehicleSelection"),
          }}
        >
          <VehicleValuationCreateByUuidView uuid={vehicleUuid} />
        </UuidExistenceWrapper>
      </Can>
    );
  }

  return null;
}
